// extracted by mini-css-extract-plugin
export var wrapper = "style-module--wrapper--25Gl9";